import { StateSchema } from 'app/config/storeConfig/types';

export const getRoutedWarehouseId = (state: StateSchema): Nullable<string> => state.warehouseMap.routedWarehouseId;
